<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-end py-0">
        <v-select
          :items="dayCountOptions"
          v-model="dayCount"
          @change="initialize"
          style="max-width: 150px"
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <TheDownloadCount
          title="Total Searches"
          :value="metrics.totalSearch"
          :periodDays="searchData"
          icon="mdi-magnify"
        />
      </v-col>
      <v-col cols="12" md="3">
        <TheDownloadCount
          title="Total Clicks"
          :value="metrics.totalClick"
          :periodDays="clickData"
          icon="mdi-cursor-default-click-outline"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="bg-white lastsearchkeywords">
          <ul>
            <li v-for="(item, index) in lastSearchKeywords" :key="index">{{ item }}</li>
          </ul>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-tabs v-model="tab" background-color="transparent" color="primary">
          <v-tab>Visited Resources</v-tab>
          <v-tab>Bookmarked</v-tab>
          <v-tab>Filters</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card color="white" flat max-height="400px" height="400px">
              <v-data-table
                :headers="headers"
                :items="visitedResources"
                class="border"
                :loading="isLoading"
                :items-per-page="5"
                loading-text="Loading... Please wait"
              ></v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card color="white" flat max-height="400px" height="400px">
              <v-data-table
                :headers="headers"
                :items="bookmarkedResources"
                class="border"
                :loading="isLoading"
                :items-per-page="5"
                loading-text="Loading... Please wait"
              ></v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card color="white" flat max-height="400px" height="400px"> 
              <v-data-table
                :headers="filterHeaders"
                :items="frequentlyUsedFilters"
                class="border"
                :loading="isLoading"
                :items-per-page="5"
                loading-text="Loading... Please wait"
              ></v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="6" class="pt-0">
        <div class="d-flex flex-wrap align-center justify-end">
          <div class="d-flex align-center">
            <span class="mx-4"> Report </span>
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="StartDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="StartDate"
                @input="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
            <span class="mx-4"> to </span>
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="EndDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="EndDate"
                @input="endDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </div>
          <v-btn color="primary" dark class="ml-2" @click="exportData" :loading="isExporting"><v-icon>mdi-cloud-download-outline</v-icon>Export</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import TheDownloadCount from "@/components/customComponents/download-count/TheDownloadCount";
import moment from "moment";

export default {
  name: "AdminUserMetrics",
  components: {
    TheDownloadCount
  },
  data: () => ({
    dayCountOptions: [
      {
        text: "1 Day",
        value: 1
      },
      {
        text: "7 Days",
        value: 7
      },
      {
        text: "14 Days",
        value: 14
      },
      {
        text: "30 Days",
        value: 30
      }
    ],
    headers: [
      {
        text: "Count",
        align: "start",
        value: "count"
      },
      { text: "Name", value: "name" }
    ],
    filterHeaders: [
      { text: "Name", align: "start", value: "name" },
      { text: "Count", value: "count" }
    ],
    projects: [],
    metrics: {},
    isLoading: false,
    tab: null,
    dayCount: 7,
    StartDate: null,
    EndDate: null,
    startDateMenu: false,
    endDateMenu: false,
    isExporting: false
  }),

  computed: {
    searchData() {
      return Object.keys(this.metrics).indexOf("periodDays") > -1
        ? this.metrics.periodDays.map(item => item.searchCount)
        : [];
    },

    clickData() {
      return Object.keys(this.metrics).indexOf("periodDays") > -1
        ? this.metrics.periodDays.map(item => item.clickCount)
        : [];
    },

    lastSearchKeywords() {
      return Object.keys(this.metrics).indexOf("listOverPeriod") > -1
        ? this.metrics.listOverPeriod.lastSearchKeywords
        : [];
    },

    bookmarkedResources() {
      if (Object.keys(this.metrics).indexOf("listOverPeriod") > -1) {
        let keys = Object.keys(this.metrics.listOverPeriod.bookmarkedResources);
        let res = [];
        for (let i = 0; i < keys.length; i++) {
          res.push({
            name: keys[i],
            count: this.metrics.listOverPeriod.bookmarkedResources[keys[i]]
          });
        }
        return res;
      } else return [];
    },

    visitedResources() {
      if (Object.keys(this.metrics).indexOf("listOverPeriod") > -1) {
        let keys = Object.keys(this.metrics.listOverPeriod.visitedResources);
        let res = [];
        for (let i = 0; i < keys.length; i++) {
          res.push({
            name: keys[i],
            count: this.metrics.listOverPeriod.visitedResources[keys[i]]
          });
        }
        return res;
      } else return [];
    },

    frequentlyUsedFilters() {
      if (Object.keys(this.metrics).indexOf("listOverPeriod") > -1) {
        let keys = Object.keys(
          this.metrics.listOverPeriod.frequentlyUsedFilters
        );
        let res = [];
        for (let i = 0; i < keys.length; i++) {
          res.push({
            name: keys[i],
            count: this.metrics.listOverPeriod.frequentlyUsedFilters[keys[i]]
          });
        }
        return res;
      } else return [];
    }
  },

  created() {
    this.initialize();
    this.EndDate = moment().format('YYYY-MM-DD');
    this.StartDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
  },

  methods: {
    ...mapActions("user", ["getUserMetrics", "getUserMetricsCSV"]),
    async initialize() {
      this.isLoading = true;
      this.metrics = await this.getUserMetrics(this.dayCount);
      this.isLoading = false;
    },

    async exportData() {
      this.isExporting = true;
      const payload = {
        StartDate: this.StartDate,
        EndDate: this.EndDate
      }
      await this.getUserMetricsCSV(payload);
      this.isExporting = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.lastsearchkeywords {
  height: 100%;
}
</style>
